<template>
    <CDropdown inNav class="c-healder-nav-items" placement="bottom-end" add-menu-classes="pt-0">
        <template #toggler>
          <CHeaderNavLink>
            <div class="c-avatar" @click="get_account_balance">
              <img
                src="assets/user.png"
                class="c-avatar-img "
              />
            </div>
          </CHeaderNavLink>
        </template>
        <div v-show="$store.state.verif">
            <CDropdownItem v-show="$store.state.perms.can_view_user_info_page"
                @click="redirect_to(`/profile/${$store.state.user_id}`)">
                <CIcon name="cil-user" />  پروفایل
            </CDropdownItem>
            <CDropdownItem @click="redirect_to(`/user/${$store.state.user_id}/password/reset`)">
                <CIcon name="cil-lock-locked" />  تغییر رمز عبور
            </CDropdownItem>
            <CDropdownItem @click="redirect_to(`/setting`)">
             <CIcon name="cil-settings" />  تنظیمات
            </CDropdownItem>
            <CDropdownItem>
                <CIcon name="cil-dollar" />  موجودی: {{account_balance}}
            </CDropdownItem>
        </div>
        <CDropdownItem @click="log_out">
            <CIcon name="cil-exit-to-app" />  خروج از حساب کاربری
        </CDropdownItem>
    </CDropdown>
</template>

<script>
export default {
    data() {
        return {
            account_balance: '',
        }
    },
    methods: {
        log_out() {
            this.$store.commit('set_on_close');
            if(this.$store.state.socket != 0){
                try{
                    this.$store.commit('socket_close');
                } catch(err){}
            }
            localStorage.clear();
            this.$store.commit('reset');
            this.$router.push('/signin');
        },
        get_account_balance() {
            this.account_balance = 'در حال دریافت...';
            this.$http.get('/users/'
                + '?id=' + this.$store.state.user_id)
                .then(res => {
                    this.account_balance = `${String(res.data[0].account_balance).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال`;
                })
        },
        redirect_to(route) {
			this.$router.push(route);
		}
    },
}
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
</style>